export const avocadostoreApp = {
  id: 102,
  name: "avocadostore",
  label: "Avocadostore",
  logo: process.env.BASE_URL + "media/shopLogos/avocadostore.svg",
  // Avocadostore has no merchant API: it pushes the order export to a webhook and fetches the stock
  // and tracking feeds from fixed URLs. There are no credentials to check, so no test connection —
  // the wizard has no credentials step, and the flag keeps useWizard's credential handling out of
  // the way (same as websales and temu).
  showTestConnection: false,
  // "migration" = initial data import, which Avocadostore does not offer. The journal stays: the
  // sales-order journal with its re-import button is the merchant's only view of the CSV import.
  // There is no CFL data set (no product export), so the journal's export tab is hidden by
  // JournalView, which only offers it when the app has a CFLDataSetId.
  areaBlacklist: ["migration"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_AVOCADOSTORE_PRESET_ID,
    // Stock and tracking are feeds Avocadostore pulls, so the generic push test workflows do not
    // apply; only the order import has a test run.
    testWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_AVOCADOSTORE_TEST_ORDER_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_AVOCADOSTORE_TEST_BATCH_ORDER_WORKFLOW_ID
    }
  }
};
